module.exports = __webpack_public_path__ + "img/81010999.f96b6010.png";